<template>
    <div :class="keyboardClass"></div>
</template>

<script>
    import Keyboard from "simple-keyboard";
    import "simple-keyboard/build/css/index.css";

    export default {
        name: "SimpleKeyboard",
        props: {
            keyboardClass: {
                default: "simple-keyboard",
                type: String
            },
            input: {
                type: String
            },
            languageStrings: {
                type: Object
            }
        },
        data: () => ({
            keyboard: null
        }),
        mounted() {
            this.keyboard = new Keyboard({
                onChange: this.onChange,
                onKeyPress: this.onKeyPress,
                layout: {
                    'default': [
                        '1 2 3 4 5 6 7 8 9 0 & -',
                        'ß q w e r t z u i o p ü',
                        'a s d f g h j k l ö ä',
                        'y x c v b n m . , {bksp}',
                        '{space} {enter}'
                    ],
                },
                display: {
                    '{bksp}': 'backspace',
                    '{enter}': this.languageStrings['suche'].toUpperCase(),
                    '{space}' : ' '
                }
            });
        },
        methods: {
            onChange(input) {
                this.$emit("onChange", input);
            },
            onKeyPress(button) {
                this.$emit("onKeyPress", button);

                /**
                 * If you want to handle the shift and caps lock buttons
                 */
                if (button === "{shift}" || button === "{lock}") this.handleShift();
            },
            handleShift() {
                let currentLayout = this.keyboard.options.layoutName;
                let shiftToggle = currentLayout === "default" ? "shift" : "default";

                this.keyboard.setOptions({
                    layoutName: shiftToggle
                });
            }
        },
        watch: {
            input(input) {
                this.keyboard.setInput(input);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import '../styles/variables.scss';



    .Search {
        .simple-keyboard {
            position: absolute;
            bottom: 120px;
            width: 721px;
            max-width: 1000px;
            padding-top: 35px;
            padding-bottom: 30px;

            @include portrait(){
                bottom: 30px;
                width: 90%;
            }

        }
        .hg-theme-default {

            .hg-button-space {
                width: 70% !important;
            }

            .hg-button-enter {
                background: $orange !important;
                color: white;
            }

            .hg-row {
                justify-content: center;
                &:first-child {
                    .hg-button {
                        background: #BFBFBF;
                        height: 27px;
                    }
                }
            }

            .hg-button {
                width: 40px;
                flex-grow: 0;
                margin: 5px;

                &.hg-button-enter {
                    width: 141px;
                }
                &.hg-button-bksp {
                    width: 72px;
                    background-image: url('../assets/backspace.svg');
                    background-repeat: no-repeat;
                    background-position: center;
                    margin-left: 67px;
                    background-color: #BFBFBF;
                    span {
                        display: none;

                    }
                }
                &.hg-button-space {
                    width: 437px !important;
                }

            }
        }
    }





</style>